import React from 'react'
import { useFeatureFlags } from '@node-space/hooks'
import { useAccountsContext } from 'hooks/context/useAccountsContext'
import Dashboard from 'pages/Dashboard'
import DevXGetStarted from 'pages/Dashboard/components/DevXGetStarted'
import Wallets from 'pages/Wallets'
import WalletsV2 from 'pages/Wallets/WalletsV2'
import { isProduction } from 'utils/environment'

export interface GetStartedProps {
  isComplianceView: boolean
  complianceViewComponent: JSX.Element
}

export const GetStarted = ({ isComplianceView, complianceViewComponent }: GetStartedProps) => {
  const { enableWalletDashboardRedirect, enableOptimizedWalletsTabs } = useFeatureFlags()

  const { isDeveloperAccount } = useAccountsContext()

  if (isComplianceView && !!complianceViewComponent) {
    return complianceViewComponent
  }

  if (isDeveloperAccount && !isProduction) {
    return <DevXGetStarted />
  }

  return enableWalletDashboardRedirect ? (
    // TODO - remove FF once v2 becomes stable https://coindirectworld.atlassian.net/browse/MXE-1378
    enableOptimizedWalletsTabs ? (
      <WalletsV2 />
    ) : (
      <Wallets />
    )
  ) : (
    <Dashboard />
  )
}
